import ProgressBar from './ProgressBar'
import React, { useMemo } from 'react'
import { useAppSelector } from '../hooks'

const CardsPlayProgress = () => {

  const progressSelector = useAppSelector(state => state.game.currentGame?.state?.progress)
  const progress = useMemo(() => progressSelector || { value: 0, text: '' }, [progressSelector])

  return (
    <>
      <div className="progress-info">{progress.text}</div>
      <ProgressBar progress={progress.value} />
    </>
  )
}

export default CardsPlayProgress
